import { defineMessages } from "react-intl";
const messages = defineMessages({
    spaceUnpublishToGMBSuccess: {
        id: "app.spaces.actions.unpublishToGMB.success.text",
        defaultMessage: "Your space have been unpublished from Google My Business.",
    },
    spaceUnpublishToGMBTitle: {
        id: "app.spaces.actions.unpublishToGMB.title.text",
        defaultMessage: "Unpublish from Google My Business",
    },
    spaceUnpublishToGMBButton: {
        id: "app.spaces.actions.unpublishToGMB.button.text",
        defaultMessage: "Unpublish",
    },
    spaceUnpublishToGMBCancelButton: {
        id: "app.spaces.actions.unpublishToGMB.cancel.button.text",
        defaultMessage: "Cancel",
    },
    spaceUnpublishToGMBFormConfimation: {
        id: "app.spaces.actions.unpublishToGMB.form.confirm.text",
        defaultMessage: "Are you sure you want to unpublish this property from Google My Business?",
    },
});
export default messages;
